import React, { useEffect } from "react";
import "./Wallet.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../features/auth/Slice";
import { formatAmount } from "../../utils/common";

function Wallet() {
  const navigate = useNavigate();
  const mainWalletAmount = 0.78;
  const thirdWalletAmount = 0.80;

  const total = mainWalletAmount + thirdWalletAmount;

  const mainPercent = total ? (mainWalletAmount / total) * 100 : 0;
  const thirdPercent = total ? (thirdWalletAmount / total) * 100 : 0;
  const dispatch = useDispatch()
  const user = useSelector((state => state.auth));

  useEffect(() => { dispatch(GETAuthLogin()) }, [dispatch]);
  return (
    <>
      <section className="Wallet">

        {/* Header */}

        <div className="wallet_header">
          <div className="back_arrow" onClick={() => { navigate(-1) }}>&#8592;</div>

          <h3>Wallet</h3>

          <div className="wallet_icon">
            <img src="/assets/images/Wallet/wallet.png" alt="wallet" />
          </div>

          <h2 className="balance">{formatAmount(user?.data?.Wallet?.amount)}</h2>
          <p className="balance_text">Total Balance</p>
        </div>


        <div className="container">

          {/* Wallet Card */}

          <div className="wallet_Page_card">

            {/* <div className="wallet_progress">

              <div>

                <div
                  className="wallet_circle"
                  style={{ "--percent": mainPercent }}
                >
                  <div className="circle_text">
                    {Math.round(mainPercent)}%
                  </div>
                </div>

                <div className="wallet_amounts">
                  <div>
                    <h4>₹{mainWalletAmount.toFixed(2)}</h4>
                    <p>Main Wallet</p>
                  </div>
                </div>

              </div>



              <div>

                <div
                  className="wallet_circle"
                  style={{ "--percent": thirdPercent }}
                >
                  <div className="circle_text">
                    {Math.round(thirdPercent)}%
                  </div>
                </div>

                <div className="wallet_amounts">
                  <div>
                    <h4>₹{thirdWalletAmount.toFixed(2)}</h4>
                    <p>3rd party wallet</p>
                  </div>
                </div>

              </div>

            </div> */}


            {/* <button className="wallet_transfer_btn">
              Main Wallet transfer
            </button> */}


            {/* Actions */}

            <div className="wallet_actions">

              <Link to={"/deposite"}>
                <div className="wallet_action">
                  <img src="/assets/images/Wallet/pocket.png" alt="deposit" />
                  <p>Deposit</p>
                </div>
              </Link>


              <Link to={"/withdraw"}>
                <div className="wallet_action">
                  <img src="/assets/images/Wallet/blue_wallate.png" alt="withdraw" />
                  <p>Withdraw</p>
                </div>
              </Link>


              <Link to={"/deposite-history"}>
                <div className="wallet_action">
                  <img src="/assets/images/Wallet/page_tag.png" alt="history" />
                  <p>Deposit History</p>
                </div>
              </Link>


              <Link to={"/withdrawal-history"}>
                <div className="wallet_action">
                  <img src="/assets/images/Wallet/transaction.png" alt="withdraw history" />
                  <p>Withdraw History</p>
                </div>
              </Link>

            </div>

          </div>


          {/* Lottery */}

          <div className="wallet_lottery">
            <div className="lottery_circle">
              <div>
                <h4>{total.toFixed(2)}</h4>
                <p>Lottery</p>
              </div>
            </div>
          </div>


        </div>

      </section>
    </>
  );
}

export default Wallet;